import Vue from 'vue'
import Confirm from './confirm.vue'

const ConfirmBox = Vue.extend(Confirm);

Confirm.install = (params) => {
  if (typeof params !== 'object') {
    params = {};
  } 

  //new出实例，渲染。
  let instance = new ConfirmBox({
    data: {
      options: params
    }
  }).$mount();

  //实例挂载到body
  document.body.appendChild(instance.$el);

  return instance.confirm();
};

export default Confirm


// WEBPACK FOOTER //
// ./src/components/common/confirm.js